import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import api from "@/lib/api";
import FreeGuideSignup from "@/components/FreeGuideSignup";

const SHOWN_KEY = "nc_exit_guide_shown";
const DEFAULT_COVER = "https://images.unsplash.com/photo-1505128798310-612a1f29c071?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export default function ExitIntentGuide() {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState({ title: "Build Your Own Mycology Lab", cover: "" });
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/free-guide")) return;            // don't nag on the guide pages
    try { if (localStorage.getItem(SHOWN_KEY) === "1") return; } catch { return; }

    api.get("/free-guide/info").then((r) => setInfo(r.data)).catch(() => {});

    let fired = false;
    const trigger = () => {
      if (fired) return;
      fired = true;
      setOpen(true);
      try { localStorage.setItem(SHOWN_KEY, "1"); } catch {}
      cleanup();
    };

    const isTouch = typeof window !== "undefined" && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
    let timer;
    const onMouseOut = (e) => { if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) trigger(); };

    if (isTouch) {
      // reliable exit detection isn't possible on mobile; reveal after a browse window
      timer = setTimeout(trigger, 30000);
    } else {
      document.addEventListener("mouseout", onMouseOut);
    }

    function cleanup() {
      document.removeEventListener("mouseout", onMouseOut);
      if (timer) clearTimeout(timer);
    }
    return cleanup;
  }, [pathname]);

  const cover = info.cover || DEFAULT_COVER;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl p-0 overflow-hidden gap-0 border-primary/30" data-testid="exit-intent-modal">
        <div className="grid sm:grid-cols-2">
          <div className="hidden sm:block relative">
            <img src={cover} alt={info.title} className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div className="p-7">
            <span className="inline-block font-mono-label text-[10px] text-primary border border-primary/40 rounded-full px-3 py-1 mb-4">
              Free · $100 Value
            </span>
            <h2 className="font-display text-2xl leading-tight mb-2">Don't leave empty-handed</h2>
            <p className="text-sm text-muted-foreground mb-5 leading-relaxed">
              Grab <span className="text-foreground">{info.title}</span> <span className="text-foreground font-semibold">free</span> — the exact
              $100 blueprint we use to build clean, contamination-proof labs. Enter your email and we'll send it now,
              plus <span className="text-primary font-semibold">15% off</span> your first order.
            </p>
            <FreeGuideSignup variant="full" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
